function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import useBackground from "../../hooks/useBackground";
import useResponsivePropsCSS from "../../hooks/useResponsivePropsCSS";
import { jsx as ___EmotionJSX } from "@emotion/core";
var COLORS = ["grey.t05", "white"];
var DEFAULT_PROPS = {
  color: "grey.t05",
  placeholder: "Please select",
  fullWidth: true,
  disabled: false,
  isValid: true,
  __internal__focus: false
};
InternalSelect.COLORS = COLORS;
InternalSelect.DEFAULT_PROPS = DEFAULT_PROPS;

function InternalSelect(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);

  var name = props.name,
      parentName = props.parentName,
      id = props.id,
      placeholder = props.placeholder,
      options = props.options,
      fullWidth = props.fullWidth,
      optional = props.optional,
      disabled = props.disabled,
      isValid = props.isValid,
      describedBy = props.describedBy,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      value = props.value,
      onChange = props.onChange,
      __internal__focus = props.__internal__focus;

  var _useBackground = useBackground(),
      inputColorMap = _useBackground.inputColorMap;

  var css = useResponsivePropsCSS(props, DEFAULT_PROPS, {
    color: function color(propsAtBreakpoint, theme, bp) {
      var _props$color;

      var color = (_props$color = _props.color) !== null && _props$color !== void 0 ? _props$color : inputColorMap[bp];
      return theme.select.getCSS({
        color: color,
        fullWidth: fullWidth,
        __internal__focus: __internal__focus
      });
    }
  });
  return ___EmotionJSX("select", {
    css: css,
    id: id,
    name: name,
    "data-parent-name": parentName,
    "aria-invalid": isValid ? null : "true",
    "aria-describedby": describedBy,
    disabled: disabled,
    value: value,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange
  }, placeholder && ___EmotionJSX("option", {
    value: "",
    disabled: !optional
  }, placeholder), options.map(function (option) {
    return (
      /* 
        Note: We use `option.label` as the key here because users shouldn't have
              multiple options with the same label.
              They can have multiple options with the same value though!
              For example:
                <option value="us">USA</option>
                <option value="us">United States</option>
      */
      ___EmotionJSX("option", {
        value: option.value,
        key: option.label
      }, option.label)
    );
  }));
}

InternalSelect.propTypes = {
  name: PropTypes.string.isRequired,
  parentName: PropTypes.string,
  id: PropTypes.string,
  color: PropTypes.oneOf(COLORS),
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  fullWidth: PropTypes.bool,
  optional: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  isValid: PropTypes.bool,
  describedBy: PropTypes.string,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  __internal__focus: PropTypes.bool
};
export default InternalSelect;